
<div class="wrapper">
    <div>
        <app-value-added-banner></app-value-added-banner>
    </div>
    <div>
        <app-value-added-content></app-value-added-content>
    </div>
</div>